import React, { useEffect, useState } from 'react';
import { OutlinedInput, MenuItem, Chip, Select, Button } from '@mui/material';
import ColorizeIcon from '@mui/icons-material/Colorize';
import api from '../../../services/api';
import AddIcon from '@mui/icons-material/Add';
import { SlidingPaneAddNew } from '../../Page/SlidingPaneAddNew';

export default function BasicSelectMUI({
  params,
  column,
}: {
  params: any;
  column: any;
}) {
  const [selectOptions, setSelectOptions] = useState<any>([]);
  const [addingEntity, setAddingEntity] = useState(false);
  const [loading, setLoading] = useState(false);

  const transformedValue = params.value;

  useEffect(() => {
    if (
      typeof transformedValue !== undefined &&
      transformedValue !== null &&
      transformedValue !== undefined
    ) {
      setSelectOptions([transformedValue]);
    }
  }, []);

  const fetchSelectOptions = async (
    searchText: string,
    columnName?: string,
    row?: any
  ) => {
    setLoading(true);

    const searchParams = new URLSearchParams({
      //searchValue: searchText,
    });

    if (column?.url) {
      api.get(`/${column?.url}`, searchParams).then((result: any) => {
        result.data.unshift({ id: 0, name: '', isButton: true });

        setSelectOptions(result.data);
        setLoading(false);
      });
    }
  };

  const onChange = (value: any) => {
    const valueForOnChange: any = selectOptions.find(
      (item: any) => item?.id === value
    );

    if (valueForOnChange?.isButton) {
      setAddingEntity(true);
    } else {
      params.api.setEditCellValue({
        id: params.id,
        field: params.field,
        value: valueForOnChange,
      });
    }
  };

  return (
    <>
      <>
        <Select
          fullWidth={true}
          onOpen={async () => {
            const options = await fetchSelectOptions('');
          }}
          label={transformedValue?.name}
          size={'small'}
          value={transformedValue?.id}
          sx={{
            '& .MuiSelect-icon': {
              display: 'none',
            },
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none',
              borderRadius: '0px',
              borderWidth: '0px',
              top: '0px',
            },
            '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
              border: 'none',
              borderRadius: '0px',
              borderWidth: '0px',
            },
            '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
              borderWidth: '0px',
              borderRadius: '0px',
            },
            '& .MuiSelect-select': {
              padding: '5px !important',
              fontSize: '14px',
              lineHeight: '18px',
            },
            '& input': {
              padding: '0px !important',
            },
            '& .MuiOutlinedInput-input.MuiSelect-select': {
              textOverflow: 'clip',
            },
          }}
          input={<OutlinedInput label="" />}
          onChange={(event) => {
            onChange(event.target.value);
          }}
        >
          {selectOptions.map((option: any, index: number) => {
            return (
              <MenuItem key={index} value={option?.id}>
                {option?.isButton && (
                  <Button
                    startIcon={<AddIcon />}
                    size={'small'}
                    variant="contained"
                    fullWidth
                  >
                    Add new
                  </Button>
                )}
                {option?.color && typeof option?.color === 'string' ? (
                  <Chip
                    style={{
                      background: `#${option?.color}`,
                      color: '#fff',
                    }}
                    icon={
                      <ColorizeIcon
                        color={'disabled'}
                        sx={{ color: 'white' }}
                      />
                    }
                    label={`#${option.name}`}
                  />
                ) : (
                  option.name
                )}
              </MenuItem>
            );
          })}
        </Select>

        {addingEntity && (
          <SlidingPaneAddNew
            schema={column?.tempSchema}
            mainSchema={column?.tempSchema}
            id={'new'}
            hasSlidingPane={false}
            onSubmit={(value: any) => {
              if (value) {
                onChange(value);
                setAddingEntity(false);
              }
            }}
            propertiesFromTable={{}}
            row={{}}
            onClose={(value) => {
              setAddingEntity(false);
            }}
          />
        )}
      </>
    </>
  );
}
